import React from 'react';
import LoginForm from '../components/auth/LoginForm';

const Login: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-16">
      <LoginForm />
    </div>
  );
};

export default Login; 